module.exports = __webpack_public_path__ + "img/banner-princiapal.fb97f7a2.svg";